import { SAFER_GAMBLING_LINK_DEFINITION, SETTINGS_LINK_DEFINITION } from '../../commonMainNavigationLinkDefinitions.ts';
import type { LinkDefinition, MainNavigationLinksConfig } from '../../mainNavigationLinks.types.ts';
import { ROUTES } from './routes/routes.ts';

const linkDefinitions: Record<string, LinkDefinition> = {
  myTickets: {
    href: ROUTES.MY_ACCOUNT.MY_TICKETS,
    labelKey: 'my_tickets',
    trackName: 'Keno tickets',
    trackContainer: 'Keno tickets',
    testId: 'my-account-my-tickets',
  },
  lotteryTickets: {
    href: ROUTES.LOTTO.PURCHASES,
    labelKey: 'lottery_tickets',
    trackName: 'Lottery tickets',
    trackContainer: 'Lottery tickets',
    testId: 'my-account-lottery-tickets',
  },
  saferGambling: SAFER_GAMBLING_LINK_DEFINITION,
  settings: SETTINGS_LINK_DEFINITION,
};

const links = ['myTickets', 'lotteryTickets', 'saferGambling', 'settings'] as const;

const MAIN_NAVIGATION_LINKS: MainNavigationLinksConfig = {
  linkDefinitions,
  links,
};

export { MAIN_NAVIGATION_LINKS };
